import toastr from 'toastr';
import _ from 'lodash';
import '../../node_modules/toastr/build/toastr.min.css';

export default {
  toast: (type, message, title, options) => {
    const opts = options || {
      positionClass: 'toast-top-center',
      closeButton: true
    };
    // If you wish to remove the icon, add the remove-icon class
    // toastr.success(message, title, {closeButton: true, toastClass: 'remove-icon', timeOut: 0, extendTimeOut: 0});
    switch (type) {
      case 'success':
        toastr.success(message, title, opts);
        break;
      case 'info':
        toastr.info(message, title, opts);
        break;
      case 'warning':
        toastr.warning(message, title, opts);
        break;
      case 'error':
        toastr.error(message, title, opts);
        break;
      default:
        toastr.success(message, title, opts);
        break;
    }
  },

  arrayToUL: theArray => {
    let returnItems = '<ul>';
    _.each(theArray, (index, value) => {
      returnItems += '<li>' + value + '</li>';
    });
    return returnItems + '</ul>';
  }
};
